<div class="header-container">
    <h1 class="header-title">{{ isCreating ? 'New Tracking Lane' : (trackingLane.name || 'Tracking Lane') }}</h1>
    <div class="header-actions-container">
        <button nz-button nzType="primary" [disabled]="!canSave" [nzLoading]="isSaving" (click)="save()">Save</button>
    </div>
</div>
<nz-spin [nzSpinning]="isLoading">
<div class="content">
    <div class="lane-data-section">
        <h3>Tracking Lane Order Cancelation Data</h3>
        <div class="lane-data-row">
            <nz-select 
                class="variable-select"
                nzPlaceHolder="Cancelled variable"
                nzShowSearch
                [nzFilterOption]="filterVariableOption"
                [(ngModel)]="trackingLane.data.variable_cancelled"
            >
                @for (col of columnDefinitions; track col.field) {
                    <nz-option nzCustomContent [nzValue]="col.field" [nzLabel]="col.headerName ?? col.field">
                        <div class="option-row">
                            <div class="option-label">{{ col.headerName ?? col.field }}</div>
                            <div class="option-field">{{ col.field }}</div>
                        </div>
                    </nz-option>
                }
            </nz-select>
            <label nz-checkbox [(ngModel)]="simulateCancelled">Simulate cancelled</label>
            @if (!previewLoaded) {
                <button nz-button nzType="default" (click)="loadPreview()">Load preview</button>
            }
        </div>
    </div>
    <div style="display: flex;">
        <tracking-lane-wheel [nodes]="resolvedNodes" [cancelled]="simulateCancelled"></tracking-lane-wheel>
        <tracking-lane-line [nodes]="resolvedNodes" [cancelled]="simulateCancelled"></tracking-lane-line>
    </div>
    <tracking-lane-config [nodes]="trackingLane.nodes" (nodesChange)="onNodesChange($event)" [currentNodeId]="currentNodeId"
        (currentNodeIdChange)="onCurrentNodeIdChange($event)"></tracking-lane-config>
</div>
</nz-spin>
